import { Box } from '@mui/material';
import Menue from '../Menue/Menue';
import Header from '../Header/Header';

const Layout = ({ children }) => {
    return (
        <Box height="100vh"  bgcolor="#ECEFF6" className="d-flex" width="100%">
            <Menue />
            <Box width="100%">
                <Header />
                <Box className="p-3 px-4"  style={{overflow:'auto'}} height="calc(100vh - 64px)">
                    {children}
                </Box>
            </Box>
        </Box>
    );
};

export default Layout;
